import styled from 'styled-components';

import { TestIdProps, withTestIdProp } from '../../../utils';

export const Input = styled('input').attrs(withTestIdProp)<TestIdProps>``;
